import React, {useContext, useState} from 'react';
import {connect, DispatchProp} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {ReactComponent as GiftSVG} from "../../../../../images/icons/gift-solid.svg";
import {ReactComponent as TrophySVG} from "../../../../../images/icons/trophy-star.svg";
import {RootState} from "../../../../../reducers";
import VoucherProductConfirmationModal from "./VoucherProductConfirmationModal";
import {VoucherApi} from "../../../../services/Api/types";
import VoucherModal from "../../../Navbar/UserDrawer/VoucherModal";
import {VoucherProductsContext} from "../../../../services/VoucherProducts/VoucherProductsContext";

interface OwnProps {
    onHide: () => void;
    setPage: (page?: string) => void;
    product: any;
    onSuccess?: (voucher?: VoucherApi) => void;
    onSuccessUserModal?: () => void;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

function VoucherProductComponent(props: Props) {
    const [modal, setModal] = useState(false);
    const product = props.product;
    const {t} = useTranslation();
    const [boughtVoucher, setBoughtVoucher] = useState<VoucherApi | undefined>();
    const {handlePromotionChange} = useContext(VoucherProductsContext);

    const isAvailableVoucher = (voucher: any) => {
        return true;
    }
    const onSuccess = (voucher?: VoucherApi) => {
        setModal(false);
        props.onSuccess?.(voucher);
        
        if (voucher) {
            setBoughtVoucher(voucher);
        }
    }

    return (
        <>
            {modal && (
                <VoucherProductConfirmationModal product={product} onSuccess={onSuccess} onHide={() => setModal(false)}
                                                 onSuccessUserModal={props.onSuccessUserModal}/>
            )}
            {
                !!boughtVoucher && (
                    <VoucherModal onHide={() => setBoughtVoucher(undefined)} show voucher={boughtVoucher}
                                  handlePromotionChange={handlePromotionChange}/>
                )
            }
            <div
                className={"voucher-card flex-fill " + (!isAvailableVoucher(product) ? ' disabled' : '')}
                onClick={(e) => setModal(true)}>

                <div className={"card-content"}>
                    <div className="card-body">
                        <div className={"card-img"}>
                            {product.image ? (
                                <img src={product.image}
                                     className="card-img-top" alt={t("modules.voucher.field.voucher_image.title")}/>
                            ) : (
                                <GiftSVG/>
                            )}
                        </div>
                        <div className={"card-text-content"}>
                            <h5 className="card-title">{product.name}</h5>
                            <p className="card-text">{product.description}</p>
                        </div>
                    </div>
                    <div className="card-footer">
                        <span className={"valid-time"}>
                            {/*<CalendarSVG /> {`${t("modules.voucher.field.valid_to.title")}: 12.01.25`}*/}
                        </span>
                        <button className="btn buy-btn">
                            {product.cost ? `${t("modules.voucher.action.buy.title")} ${product.cost} ${t("common.word.points.shortcut")}` : t("modules.voucher.action.collect_for_free.title")}
                            {product.cost > 0 && <TrophySVG className="ms-1"/>}
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

const mapStateToProps = (state: RootState) => ({})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(VoucherProductComponent));

